import {
  AfterContentInit,
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { DevicesManagerService } from '../../../services/devices-manager.service';
import { MapService } from '../../../services/map.service';
import { ClustersDevicesLayer } from '../../../services/map/cluster-devices-layer.service';
import { DevicesLayerService } from '../../../services/map/devices-layer.service';
import { PermissionService } from '../../../services/permission.service';
import HasPermissionDirective from '../../../utils/directives/has-permission.directive';
import { DEVICES } from '../../devices/devices-routing.constants';

@Component({
  selector: 'widget-map',
  templateUrl: './widget-map.component.html',
  styleUrls: ['./widget-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, HasPermissionDirective, RouterLink, TranslatePipe],
})
export class WidgetMapComponent implements OnInit, OnDestroy, AfterContentInit {
  private _devicesLayerService = inject(DevicesLayerService);
  private _clustersDevicesLayer = inject(ClustersDevicesLayer);
  private _devicesManagerService = inject(DevicesManagerService);

  public readonly DEVICES = DEVICES;
  private mapService = inject(MapService);
  public permissionService = inject(PermissionService);
  public $filters = computed(() => {
    return {
      devices:
        !!this._devicesManagerService.$filters().units.length ||
        !!this._devicesManagerService.$filters().movingStatus.length ||
        !!this._devicesManagerService.$filters().type.length,
      landmarks: !!this.mapService.$landmarksFilters()?.length,
    };
  });

  ngOnInit(): void {
    this.mapService.zone.runOutsideAngular(() => {
      const fragment = document.createDocumentFragment();
      if (document.getElementById('map')) {
        this.mapService.mapDiv = fragment.appendChild(document.getElementById('map'));
      }
    });
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.mapService.initMapOnDashBoard();
      this._devicesLayerService.fit();
      this._clustersDevicesLayer.fit();
    }, 100);
  }

  ngOnDestroy(): void {
    if (document.getElementById('map-container') && this.mapService.mapDiv) {
      this.mapService.dashBoardDestroy();

      this._devicesLayerService.fit({ addPadding: true });
      this._clustersDevicesLayer.fit();
    }
  }
}
